<template>
<div class="index page_shop bodyBottom page_home">
    <div class="index_top">
        <page-search placeholder="搜索" :readonly="true" class="page-search" fieldClass="search_field" :righticon="this.publicPath + 'statics/images/search_ico.png'" :searchrighticon="
          this.publicPath + 'statics/images/search_shop_car.png'
        " :searchlefticon="this.publicPath + 'statics/images/search_jiang.png'"></page-search>
        <van-swipe :autoplay="3000" class="swiper_style1">
            <van-swipe-item v-for="(item, index) in bannerList" :key="index">
                <van-image width="100%" height="100%" :src="imageUrl+item.thumb" v-if="item.link_type == 0 || item.link_type == 4" @click.stop="swiper_img_click(item)" />
				<div class="ymweapp-wrap" style="height:3.6rem;">
						<img :src="imageUrl+item.thumb" alt="" class="" style="width:100%;height:100%;">
						<wx-open-launch-weapp id="ymweapp" :username="item.link_type == 1 ? 'gh_c4d2ea12156e' : item.link_type == 2 ? 'gh_ac3aa3211774' : item.link_type == 3 ? 'gh_13d4df09e5c2' : item.link_type == 5 ? 'gh_0e1240455bda':''  " :path="item.url? item.url : 'pages/index/index'">
							<script type="text/wxtag-template">
								<style>.ymweapp-tu {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
								<div class="ymweapp-tu"></div>
							</script>
						</wx-open-launch-weapp>
					</div>
            </van-swipe-item>
        </van-swipe>
    </div>
    <!-- 各区分类 -->
    <div class="index_con">
        <div class="tab_wrap">
            <van-tabs v-model="active" :border="false" title-active-color="#B50001" title-inactive-color="#333333" swipe-threshold="6" @click="cartClick">
                <van-tab v-for="(item, index) in tabcolumn" :key="index" :name="item.name">
                    <div slot="title">{{ item.txt }}</div>
                </van-tab>
            </van-tabs>
            <div class="zhankai" @click="goodsFenlei">
                <!-- <img :src="this.publicPath+'/statics/images/icon_01.png'" alt="" class="icon"> -->
            </div>
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadGoodsList">
                    <div class="datalist">
                        <ul class="list">
                            <li v-for="(goods,index) in goodsList" :key="index">
                                <div class="item single" v-if="goods.type == 1" @click="goZhuanTiDetail(goods)">
                                    <div :class="goods.is_blockchain ? 'thumb blockchain' : 'thumb'">
                                        <img :src="imageUrl+goods.thumb" alt="" />
                                    </div>
                                    <!-- <div class="thumb_mask">
                                        <p class="desc">{{ goods.name }}</p>
                                    </div> -->
                                </div>
                                <div v-if="goods.type == 2" @click="goShopDetail(goods)" class="item">
                                    <div class="thumb">
                                        <!-- <img :src="goods.good_thumb ? goods.good_thumb : $publicData.intangibleDefault" alt="" /> -->
                                        <van-image class="vanImage" fit="contain" :show-error="false" :show-loading="false" :src="goods.good_thumb ? imageUrl+goods.good_thumb : $publicData.intangibleDefault" />
                                    </div>
                                    <!-- <div class="item_xinxi">
                                        <div class="title_wrap">
                                            <span class="icon_self" v-if="goods.is_self">自营</span>
                                            <span class="icon_new" v-if="goods.is_new">最新</span>
                                            <span class="title">{{ goods.good_title }}</span>
                                        </div>
                                        <div class="info clearfix">
                                            <span class="f-l price">¥{{ goods.good_price }}</span>
                                            <span class="f-r source">{{ goods.tradesman_name }}</span>
                                        </div>
                                    </div> -->
                                    <div class="item_xinxi">
                                        <div class="title_wrap single">
                                            <div class="title_tag">
                                                <span class="icon_self" v-if="goods.is_self">自营</span>
                                                <span class="icon_new" v-if="goods.is_new">最新</span>
                                            </div>
											<span v-if="goods.is_self && goods.is_new" class="title title1 slh_s"> {{ goods.good_title }}</span>
											<span v-else-if="goods.is_self || goods.is_new" class="title title2 slh_s"> {{ goods.good_title }}</span>
											<span v-else class="title title3 slh_s"> {{ goods.good_title }}</span>
                                        </div>
                                        <div class="info clearfix">
                                            <div class="shop_name f-l slh_s">{{ goods.tradesman_name?goods.tradesman_name:'' }}</div>
                                            <div class="source f-r">{{ goods.place }}</div>
                                        </div>
                                        <div class="info">
                                            <span class="f-l price">¥{{ goods.good_price }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="item banner" v-if="goods.type == 3" @click="goZhuanTiDetail(goods)">
                                    <!-- <van-image :src="goods.thumb" class="img_wrap" /> -->
                                    <!-- <img :src="goods.thumb" alt="" /> -->
                                    <div class="img_wrap">
                                        <img :src="imageUrl+goods.thumb" alt="" />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "home-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            banners: [
                // {image:'/statics/images/temp/011.png',url:'1'},
                {
                    image: process.env.BASE_URL + "statics/images/temp/0.png",
                    url: "2",
                },
                {
                    image: process.env.BASE_URL + "statics/images/temp/1.png",
                    url: "3",
                },
            ],
            active: "a",
            tabcolumn: [], //分类展示数据
            goodsCateList: [], //分类返回数据
            goodsList: [], //商品列表
            bannerList: [], //banner
            token: null,
            finished: false,
            page: 1,
            size: 10,
            loading: false,
            refreshing: false,
            cate_id: null, // 分类id   全部为0,不请求接口
            imageUrl: this.$publicData.uploadImage,
            shareConfig: null // 分享的相关配置
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '商城',
                    levitate: true,
                    showStatusBar: true,
                    hiddenBack: true
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    } else {
                        this.token = "";
                    }
                    this.loadGoodsCates();
                    this.loadGoodsList();
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
        }
        this.loadGoodsCates();
        // this.loadGoodsList();
		this.getBannerData();
		// 调起 获取微信分享参数函数 -- 弃用,改成统一配置的
        // this.getShareData()
    },
    methods: {
        // 获取数据
        getBannerData() {
            this.$api.index.index().then((res) => {
                if (res.code == 200) {
                    this.bannerList = res.result.banner;
                }
            });
        },
        loadGoodsCates() {
            var params = {
                token: this.token,
            };
            this.$api.shop.goodsType(params).then((res) => {
                if (res.code == 200) {
                    console.log(res);
                    this.goodsCateList = res.result;
                    var cateList = [{
                        name: 0,
                        txt: "全部"
                    }];
                    for (let i = 0; i < this.goodsCateList.length; i++) {
                        const cate = this.goodsCateList[i];
                        var newCate = {
                            name: cate.id,
                            txt: cate.name
                        };
                        cateList.push(newCate);
                    }
                    this.tabcolumn = cateList;
                } else {
                    this.$toast(res.message);
                }
            });
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.page = 1
            this.loadGoodsList();
        },
        loadGoodsList() {
            var params = {
                token: this.token,
                page: this.page,
                size: this.size
            };
            if (this.cate_id != 0) {
                params.cate_id = this.cate_id
            }
            params.is_pos = 1
            console.log(params);
            this.$api.shop.goodsList(params).then((res) => {
                if (res.code == 200) {
                    var oldList = this.goodsList;
                    if (this.page == 1) {
                        oldList = []
                    }
                    var list = res.result.list;
                    var special = res.result.special;
                    if (special.length > 0) {
                        list.splice(0, 0, special[0]);
                    }
                    if (special.length > 1) {
                        list.splice(6, 0, special[1]);
                    }
                    for (let i = 0; i < list.length; i++) {
                        var goods = list[i];
                        if (i == 0 && special.length > 0) {
                            goods.type = 1;
                        } else if (i == 6 && special.length > 1) {
                            goods.type = 3;
                        } else {
                            goods.type = 2;
                        }
                        oldList.push(goods)
                    }
                    this.goodsList = oldList

                    if (oldList.length >= res.result.total) {
                        // 数据全部加载完
                        this.finished = true
                        this.refreshing = false
                        return;
                    }
                } else {
                    this.finished = true
                    this.$toast(res.message);
                }
                this.page++;
                this.refreshing = false
                this.loading = false;
            });
        },
        cartClick(name) {
            console.log('cartClick', name);
            this.cate_id = name
            this.page = 1
            this.goodsList = []
            this.loadGoodsList()
        },
        // 点击轮播图
        swiper_img_click(item) {
            console.log(item);
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
                    'data': {
                        'url': item.url
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                window.open(item.url)
            }
        },
        // 商品详情
        goShopDetail(goods) {
            // console.log('商品详情',goods)
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var p = "?goodsId=" + goods.good_id;
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/shop/detail" + p
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                this.$router.push({
                    path: "/shop/detail",
                    query: {
                        goodsId: goods.good_id,
                    },
                });
            }
        },
        // 专题详情 TODO
        goZhuanTiDetail(goods) {
            console.log('goods', goods)
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var p = "?specialId=" + goods.id;
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/goods/special" + p
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                this.$router.push({
                    path: "/goods/special",
                    query: {
                        specialId: goods.id
                    },
                });
            }
        },
        // 商品分类
        goodsFenlei() {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/goods/fenlei"
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                this.$router.push({
                    path: "/goods/fenlei"
                });
            }

        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: '时代记忆商城', // 分享标题
                    desc: '时代记忆', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.domain + that.$publicData.logo, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
	/* 轮播图上的广告位 */
	.swipe_wrap .ymweapp-wrap{
		position: relative;
	}
	.swipe_wrap .ymweapp-wrap #ymweapp{
		width:100%;
		height:100%;
		position: absolute;
		top: 0;
		left: 0;
	}
</style>
